import {useEffect, useState} from 'react'
import {createDirectus, rest, sleep} from '@directus/sdk'

import {BrowserRouter, Route, Routes} from 'react-router-dom'
import HomePage from './pages/HomePage'
import EventsOverviewPage from './pages/EventsOverviewPage'
import {Footer} from './components/layout/Footer'
import {Header} from './components/layout/Header'
import LoadingCurtain from './components/parts/LoadingCurtain'
import {EventDetailPageHOC} from './pages/EventDetailPage'
import GuideOverviewPage from './pages/GuideOverviewPage'
import {$t, Languages} from './app/Languages'
import DataProtectionPage from './pages/DataProtectionPage'
import VOPPage from './pages/VOPPage'
import ReactComponent from './app/ReactComponent'
import WhoWeArePage from './pages/WhoWeArePage'
import PageDetailPage, {PageDetailPageHOC} from './pages/PageDetailPage'
import {GuideOverviewByCategoryPageHOC} from './pages/GuideOverviewByCategory'
import {Glow} from './components/helpers/glow/Glow'

export default class Root extends ReactComponent {
  state = {
    curtain: true,
    loading: true,
    menuActive: false,
  }

  closeMenu (){
    void this.updateState({menuActive: false})
  }

  async componentDidMount() {
    const api = createDirectus('https://admin.trailsoficeandfire.com').with(rest())

    //Page ready
    document.querySelector('html').classList.add('ready')
    const glow = new Glow()

    await Promise.all([
      await Languages.get().isLoading(),
      await sleep(500)
    ])


    await this.updateState({
      loading: false,
    })

    await sleep(300)

    await this.updateState({
      curtain: false,
    })
  }

  render () {

    return (
      <BrowserRouter>
        <div className="App">

          <LoadingCurtain active={this.state.curtain} loading={this.state.loading}/>

          <Header
            active={!this.state.loading}
            menuActive={this.state.menuActive}
            closeMenu={() => {this.closeMenu()}}
            setMenuActive={(value) => {void this.updateState({menuActive: !!value})}}
          />

          <main>

            <Routes>
              <Route path="/" element={<HomePage/>}></Route>
              <Route path="/who-we-are" element={<WhoWeArePage  />} />
              <Route path="/events" element={<EventsOverviewPage/>} />
              <Route path="/events/:id" element={<EventDetailPageHOC/>} />
              <Route path="/online-guide" element={<GuideOverviewPage/>} />
              <Route path="/online-guide/:slug" element={<GuideOverviewByCategoryPageHOC/>} />
              <Route path="/online-guide/:slug/:slug_post" element={<PageDetailPageHOC/>} />
              <Route path="/data-protection" element={<DataProtectionPage/>} />
              <Route path="/vop" element={<VOPPage/>} />
            </Routes>

          </main>

          <Footer active={this.state.loading}/>

        </div>
      </BrowserRouter>
    )
  }
}
